<template>

<div class="tree">

    <core-filter-advanced-builder-group :group="filter" :level="1" v-if="filter.rules.length" />

    <div class="tree-prompt" v-if="!filter.rules.length" v-on:click="onPromptClick">

        <p>Add your first rule to start building your advanced filter.</p>

        <button class="tree-button">Start</button>

    </div>

</div>

</template>

<script>

export default {

    props: ['filterName'],

    data: function() {

        return {
            filter: {
                id: '',
                logic: 'and',
                rules: []
            },
            index: []
        }

    },

    created: function() {

        this.$pubsub.$on('filter.rule.confirm', this.onRuleConfirm.bind(this))
        this.$pubsub.$on('filter.rule.remove', this.onRuleRemove.bind(this))
        this.$pubsub.$on('filter.group.add', this.onGroupAdd.bind(this))
        this.$pubsub.$on('filter.group.convert', this.onGroupConvert.bind(this))
        this.$pubsub.$on('filter.group.remove', this.onGroupRemove.bind(this))
        this.$pubsub.$on('filter.logic.change', this.onLogicChange.bind(this))

        this.initFilter()

    },

    beforeDestroy: function() {

        this.$pubsub.$off('filter.rule.confirm', this.onRuleConfirm.bind(this))
        this.$pubsub.$off('filter.rule.remove', this.onRuleRemove.bind(this))
        this.$pubsub.$off('filter.group.add', this.onGroupAdd.bind(this))
        this.$pubsub.$off('filter.group.convert', this.onGroupConvert.bind(this))
        this.$pubsub.$off('filter.group.remove', this.onGroupRemove.bind(this))
        this.$pubsub.$off('filter.logic.change', this.onLogicChange.bind(this))

    },

    watch: {

        filter: {

            deep: true,

            handler: function() {

                if (this.filter.rules.length) this.$store.commit('filter/' + this.filterName + '/advanced', this.filter)

            }

        },

        value: function() {

            this.initFilter()

        }

    },

    computed: {

        value: function() {

            return this.$store.getters['filter/' + this.filterName + '/advanced']

        }

    },

    methods: {

        initFilter: function() {

            if(this.$_.isObject(this.value) && !this.$_.isArray(this.value)) {

                this.$vueset(this, 'filter', this.value)

            } else {

                this.$vueset(this, 'filter', {
                    id: this.generateID(),
                    logic: 'and',
                    rules: []
                })

            }

        },

        generateID: function() {

            var id

            while(!id || this.$_.contains(this.index, id)) {

                id = Math.random().toString(36).substring(2, 8)

            }

            this.index.push(id)

            return id

        },

        findById: function(id) {

            const stack = [this.filter]

            while (stack.length) {

                const node = stack.pop()

                if (node.id === id) return node

                if (node.rules) {

                    for (let i = node.rules.length - 1; i >= 0; i--) {

                        stack.push(node.rules[i])

                    }

                }

            }

            return false

        },

        findParentById: function(id) {

            const stack = [{ parent: null, node: this.filter, index: -1 }]

            while (stack.length) {

                const result = stack.pop()

                if (!result.node || !Array.isArray(result.node.rules)) continue;

                for (let i = 0; i < result.node.rules.length; i++) {

                    const child = result.node.rules[i]

                    if (child.id === id) {

                        return { parent: result.node, index: i }

                    }
                
                    stack.push({ parent: result.node, node: child, index: i });
                }

            }

            return false

        },

        addItem: function(id, model) {

           var group = this.findById(id)

           if(group) group.rules.push(model)

        },

        removeItem: function(id) {

           var result = this.findParentById(id)

           if(result) result.parent.rules.splice(result.index, 1)

        },

        onRuleConfirm: function(e) {

            if (e.model.id) {

                var item = this.findById(e.model.id)

                if(item) {

                    this.$vueset(item, 'rule', e.model.rule)
                    this.$vueset(item, 'links', e.model.links)

                }

            } else {

                var model = this.$util.copy(e.model)

                model.id = this.generateID()

                this.addItem(e.group, model)

            }

        },

        onRuleRemove: function(e) {

            this.removeItem(e.id)

        },

        onGroupAdd: function(e) {

            this.addItem(e.group, {
                id: this.generateID(),
                logic: 'and',
                rules: []
            })

        },

        onGroupRemove: function(e) {

            this.removeItem(e.id)

        },
        
        onGroupConvert: function(e) {

            var item = this.findById(e.id)

            item.id = this.generateID()

            this.$vueset(item, 'rules', [this.$util.copy(item)])
            this.$vueremove(item, 'rule')
            this.$vueremove(item, 'links')

        },
        
        onLogicChange: function(e) {

            var item = this.findById(e.id)

            if (item) item.logic = e.logic

        },

        onPromptClick: function() {

            this.$pubsub.$emit('open.modal', {
                id: 'filterDirectory',
                group: this.filter.id
            })

        }

    }

}

</script>

<style scoped>

.tree {
    padding: 0px;
}

.tree-prompt {
    color: #fff;
    font-size: 20px;
    text-align: center;
    padding: 16px;
    line-height: 20px;
    height: 100%;
    display: flex;
    align-items: center;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.is-mobile .tree-prompt {
    font-size: 16px;
    line-height: 18px;
    color: #343434;
}

.tree-prompt p {
    opacity: 0.75;
}

.tree-button {
    background-color: #4881bb;
    color: #fff;
    margin-top: 15px;
    font-size: 16px;
    font-weight: 400;
    padding: 0px 20px;
    border-radius: 4px;
    line-height: 40px;
}

</style>
